
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqKPwe6mpC1h8zBV_ud_45NS15bdUHGVMahd743Vy46_45w1gMeta } from "/codebuild/output/src387477896/src/src/pages/faq.vue?macro=true";
import { default as menuj3NwXPra35ctpBr_gBCoTsJLDypazBNr6beLHkyKBnUMeta } from "/codebuild/output/src387477896/src/src/pages/menu.vue?macro=true";
import { default as indexrL5Kn0oRVpKVxUnguWrgBH6fvitt9Wb88pds6yERYxUMeta } from "/codebuild/output/src387477896/src/src/pages/index.vue?macro=true";
import { default as contactKFZpQB2661lNSeNFvx1fvQw8VDNM3aaqlHJoqqnT_45b8Meta } from "/codebuild/output/src387477896/src/src/pages/contact.vue?macro=true";
import { default as tutorialJd4_C0gP_NvP7bU2PPz6Q7w9yP2iO3Out_MYVdQSyysMeta } from "/codebuild/output/src387477896/src/src/pages/tutorial.vue?macro=true";
import { default as agreementFgSue7eE2wEwWIVn_yQ8TjTW8XkjfUKz_bs6rqvVn8AMeta } from "/codebuild/output/src387477896/src/src/pages/agreement.vue?macro=true";
import { default as about_45passyHM1YyJwN0O6qS5u_45HS3UKyzaiZtWb2cv_6JzwoFd1YMeta } from "/codebuild/output/src387477896/src/src/pages/about-pass.vue?macro=true";
import { default as index6Ng7vmohls1u8eoxWOchbEuQilYzgvJmTH6FFsSWtF4Meta } from "/codebuild/output/src387477896/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93smC_45_cp4iuSM2iuKe8AqaTrV7rqoXK1W_45wJcSBh2P0gMeta } from "/codebuild/output/src387477896/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceoi_45k_45XophogfvXmZIBf7bB_45vSNsmOmXcyaDtZpnXKAoMeta } from "/codebuild/output/src387477896/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93_3XopxfcM18QskrwVfh5uW2WFibLKgknNXYphwTX2gYMeta } from "/codebuild/output/src387477896/src/src/pages/notice/[id].vue?macro=true";
import { default as indexGOnrRMzLstwkWYtT7uHlZUNuZRSFXtS5qCBeRr4LR9sMeta } from "/codebuild/output/src387477896/src/src/pages/coupon/index.vue?macro=true";
import { default as indexbwv2rbnC6eQ_45OmIudcIC9TfsHQRhtOOWxGKI6LJLD_45YMeta } from "/codebuild/output/src387477896/src/src/pages/mypage/index.vue?macro=true";
import { default as indexUSVV_95nO3vx7NEBYQE3G7M70t78wGOGbnjIXM46OOIMeta } from "/codebuild/output/src387477896/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93sfZ4xc7UGuGYns6qB6lz1r5o2Q4zdgx4h0_L_B0G7jEMeta } from "/codebuild/output/src387477896/src/src/pages/parking/[id].vue?macro=true";
import { default as index_45jZY2g42gGjF6c7_45RyuWi89U_ZA5o8TcCwIVZQcAuDUMeta } from "/codebuild/output/src387477896/src/src/pages/history/index.vue?macro=true";
import { default as indexlm5uPnbfizKoXnEqtm4jZXDG818lxf0lhDc_45wR_XyFwMeta } from "/codebuild/output/src387477896/src/src/pages/monthly/index.vue?macro=true";
import { default as indexUq6FBOV0yVbja5d9N_BMH5cdKgYd1PPfrf_G6BdXbv8Meta } from "/codebuild/output/src387477896/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexCqy0z0sRl_LSiakPiYTfWLIpQyy2huTlDxevZNtpzhkMeta } from "/codebuild/output/src387477896/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavipK5D05NOz75H6sMJk2NtP98LkHRm4C7XCqUYCyMJj_45QMeta } from "/codebuild/output/src387477896/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editj1Udo2oM4mMO4TW56xsOoL_hAW1ACvY4P21z_MPgFlkMeta } from "/codebuild/output/src387477896/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementp2NPAn_45dZmZSYxNv6YhrAdYqnS1M3_45QkTF5JDgOkCycMeta } from "/codebuild/output/src387477896/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexWvw7Pq_sGXKLSfTVcfkxePMQWqw3dQX_WAhEDW_60dUMeta } from "/codebuild/output/src387477896/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453d3LIUkky7m0FY_D3zKoDCDotoWIptIIPhxbF0L_Tx32kMeta } from "/codebuild/output/src387477896/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmG4CjWqWUV3RoCk240lU81RYldSlbVWTALhqGFFV_45iSYMeta } from "/codebuild/output/src387477896/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexBjPf0P0DYemP6ei2MviyOWZXAxkXVcVOzgWPXRFW3NIMeta } from "/codebuild/output/src387477896/src/src/pages/card/create/index.vue?macro=true";
import { default as indexmK6It2rCVWDc7_45DklwKUYxBr6ninHCaHv34RpnegZq8Meta } from "/codebuild/output/src387477896/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmLKkpKYTS1xQiicHLE_453dhoZq5yNCnpHQYy_HVayUNqAMeta } from "/codebuild/output/src387477896/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmgVWfq9Gm8uLHjBOWyczRik6XPi05bOaSLFMF2sIx2G8Meta } from "/codebuild/output/src387477896/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeYmxjMrF9aQ5p_FtMRx7k7TeSSe4tPj52Dowqts1uJgsMeta } from "/codebuild/output/src387477896/src/src/pages/membership/complete.vue?macro=true";
import { default as registerH3pjgGIY_45wEQ7HXqrpjmmqMSnKJwKjBKEp4bU9Xsq5EMeta } from "/codebuild/output/src387477896/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93f_45I1DAeRuh7s0F2_45WSybbwo8giV8K6QxH3_45mP_yxdGcMeta } from "/codebuild/output/src387477896/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmClahbcRjAv9KibSYVegmylD0zvUoA2Gb2ZYKXmJMSHIMeta } from "/codebuild/output/src387477896/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93wmEmGytLReyK_1Nc5EBoIi348VBUEqkruIT2v7aMQXcMeta } from "/codebuild/output/src387477896/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexUlde6vF_45Uqm9QflVCsCUrPWq_45ph5aX_45xjN6ZmIza9dsMeta } from "/codebuild/output/src387477896/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codemVTsrzYkDWPQcX8plyBecLr_YHaeGSblh5veMjVqdK4Meta } from "/codebuild/output/src387477896/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45coderP2R65q3H7xPmby7ImM3f20Qscl1g82JRXuu8ufF25YMeta } from "/codebuild/output/src387477896/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeHMKb78EPDFXWuhTeyGf4TAkUVpPqwmRqssZ8oMx0DTwMeta } from "/codebuild/output/src387477896/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerz9G7zSH_45MPFItXpF6gnlA2Pdyoka1VTEsDON1PC1xngMeta } from "/codebuild/output/src387477896/src/src/pages/contact-form/register.vue?macro=true";
import { default as completepSn1fkzQLKPLfTVHQnlmPPAgwEfRdgPSoaoUQke3JPoMeta } from "/codebuild/output/src387477896/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexXfIVd01AyXMzzW3epR2j8_NsV2msg8d21ryJaEjElwwMeta } from "/codebuild/output/src387477896/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmqDqfa_JsLMXUuZZldkTH3u2ZKIwbdscTJJvvlilT8cgMeta } from "/codebuild/output/src387477896/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeOOvr_45imNa1lWVjTVHGmIIaFhpGu2GkdYZz7PuZz7PsMMeta } from "/codebuild/output/src387477896/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexJ9FTsAUhcg_sChC6xem2p5jXdzUk_45zb3ynNkSiUuD3oMeta } from "/codebuild/output/src387477896/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93tT_tadncBwXneBu5UZEWSQV_45Rrc91Tz73qrgYM0LnXcMeta } from "/codebuild/output/src387477896/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completekGH6GPuzjGGeS9ipX4xaNKRdUc5AgXys390NAufxov0Meta } from "/codebuild/output/src387477896/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasw0jNSj2HELd1Xz712n_45aii5RTZ83RTQLZYlAMsvNpSEMeta } from "/codebuild/output/src387477896/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleaMHItxcQdmcivFOgDorjujK8jMUJGhQbNALNaRD1oFoMeta } from "/codebuild/output/src387477896/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailQO9abMdCqGBCcHXFM5sPNLGQdww99Ci3wdQ_45INuWsm0Meta } from "/codebuild/output/src387477896/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmaO1YnkyiqPhxfbXytpvxfC_45bHG6JP099ARaRCa_45HU20Meta } from "/codebuild/output/src387477896/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentmtqrHc8ZU2p7BUwPifow9bR1JT9xme81lDKqsWzfJLsMeta } from "/codebuild/output/src387477896/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmnOGt0wxMFiTZrATvJ7uWCt9ZdfOyoCMDEhl4kiihmHYMeta } from "/codebuild/output/src387477896/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedategVmcbfFz5GW3eNY5uDNnhXm4xSxZdnAL9cY2MlaqInsMeta } from "/codebuild/output/src387477896/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completemKq55I7_454OJzxQ8vlcQQDbMblneIi18xvJ7H3tDBkT0Meta } from "/codebuild/output/src387477896/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code1hdFF_45PlplRNeDzZdSXN_45ufSI10YIF9fmBwKAPoP3D8Meta } from "/codebuild/output/src387477896/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordCaQDRz3BLeqDdk53dJGTovAXPvGLG7G7p7bzS0rUr8sMeta } from "/codebuild/output/src387477896/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45alias5cR5WhoresqD21xmjhRWfMo6_YVVe4eSSbDspBnntKcMeta } from "/codebuild/output/src387477896/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerlMPOjo3XKpTJj_45koLmiPlGY_Eg_45kPO2zGlzLqy3I8YQMeta } from "/codebuild/output/src387477896/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codefQO5oA0ZLp3MB01n72BaYL74HPSLMMxPveCz7QBqVTUMeta } from "/codebuild/output/src387477896/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexzMo_IDkrZWNCNDqt_45ClCitQaWbC9gwWa_kHECQpJeNEMeta } from "/codebuild/output/src387477896/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexOleQJ8wU14vVFsF1RIFAh9tBtVA8XKNYacGHLUbVpa0Meta } from "/codebuild/output/src387477896/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexkuEGZWRtObT7ns1mg7iTgecgjW919cSyqL9LIt8DdJcMeta } from "/codebuild/output/src387477896/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexR3nrlukIUsdBau1VP_O4zpjo_Ryhi_45xNnZIXvhApCeAMeta } from "/codebuild/output/src387477896/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatec3aa1TLsm9WKTWAsUro_45EBxhtZq1TMSaTG5cvxgLLTEMeta } from "/codebuild/output/src387477896/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completepl3e_Uzyh_45ia1es_45BZKtsujBu_hsaQbtXe6Fk5C7SpoMeta } from "/codebuild/output/src387477896/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmDn3q524Y_453tJZapTB89baruz1h1ikzF7qDmN_45Y_45WUdcMeta } from "/codebuild/output/src387477896/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexw_45SIt1EV5YOygjcD8uunS2KJcquEOc6yd_A_454RCv1wYMeta } from "/codebuild/output/src387477896/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete6hC_t5MCHm0iwjqnqfOdLgM1euTIQ_45iAf_45d_45jDo8OtAMeta } from "/codebuild/output/src387477896/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateXl2WyCyKbmLmRdQVTIo2RxEoNVXSGCZFo812U_45YjDHkMeta } from "/codebuild/output/src387477896/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexl8lye2LKw8dPE_45INQmfRumzldQTVMTdsJAMR308Zw2IMeta } from "/codebuild/output/src387477896/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as index7ZTMmQ6v675nLPYkGcaupeTdBELuUP0Ni_45nbKYM0gL4Meta } from "/codebuild/output/src387477896/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete1Aj3UaXxFHTHeszTumwx9N_45I_45MiCV9qBsOhxslxDxKMMeta } from "/codebuild/output/src387477896/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexglPrq3GH5w6LxIKoiNzOUJqbjHLz_xOyMMHLuWkoc78Meta } from "/codebuild/output/src387477896/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeNuk4_45vgBP6bBTB4p7UT96WSr7qRtJIXhSDV7nlevNZMMeta } from "/codebuild/output/src387477896/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexcgvmT5jI_ND7tgD6luAip3cmzUACgVe6eyLU4vYbYEIMeta } from "/codebuild/output/src387477896/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indext0_45YoxIw2QZ5aBUcmTb9Eefl47v2p1a6WT9Gu_45OKrBUMeta } from "/codebuild/output/src387477896/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexqL7g0553gA6YE_S7aHrOAnoZezT03sJsAOowBeAlGB4Meta } from "/codebuild/output/src387477896/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatenoNiaS_45Jm9xc08bWZoCVkmQxcx8q1UKXyfZFrfXDLWsMeta } from "/codebuild/output/src387477896/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmhrSrhLz6vHo1bTkT8n32GVoO6QaRpcNDE41Y7RnFkTIMeta } from "/codebuild/output/src387477896/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src387477896/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuj3NwXPra35ctpBr_gBCoTsJLDypazBNr6beLHkyKBnUMeta || {},
    component: () => import("/codebuild/output/src387477896/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexrL5Kn0oRVpKVxUnguWrgBH6fvitt9Wb88pds6yERYxUMeta || {},
    component: () => import("/codebuild/output/src387477896/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src387477896/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src387477896/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src387477896/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src387477896/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src387477896/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src387477896/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src387477896/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src387477896/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexGOnrRMzLstwkWYtT7uHlZUNuZRSFXtS5qCBeRr4LR9sMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src387477896/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src387477896/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src387477896/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index_45jZY2g42gGjF6c7_45RyuWi89U_ZA5o8TcCwIVZQcAuDUMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src387477896/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src387477896/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexUq6FBOV0yVbja5d9N_BMH5cdKgYd1PPfrf_G6BdXbv8Meta || {},
    component: () => import("/codebuild/output/src387477896/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexCqy0z0sRl_LSiakPiYTfWLIpQyy2huTlDxevZNtpzhkMeta || {},
    component: () => import("/codebuild/output/src387477896/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src387477896/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src387477896/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src387477896/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src387477896/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src387477896/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src387477896/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexBjPf0P0DYemP6ei2MviyOWZXAxkXVcVOzgWPXRFW3NIMeta || {},
    component: () => import("/codebuild/output/src387477896/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmLKkpKYTS1xQiicHLE_453dhoZq5yNCnpHQYy_HVayUNqAMeta || {},
    component: () => import("/codebuild/output/src387477896/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmgVWfq9Gm8uLHjBOWyczRik6XPi05bOaSLFMF2sIx2G8Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src387477896/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeYmxjMrF9aQ5p_FtMRx7k7TeSSe4tPj52Dowqts1uJgsMeta || {},
    component: () => import("/codebuild/output/src387477896/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerH3pjgGIY_45wEQ7HXqrpjmmqMSnKJwKjBKEp4bU9Xsq5EMeta || {},
    component: () => import("/codebuild/output/src387477896/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src387477896/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmClahbcRjAv9KibSYVegmylD0zvUoA2Gb2ZYKXmJMSHIMeta || {},
    component: () => import("/codebuild/output/src387477896/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src387477896/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src387477896/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codemVTsrzYkDWPQcX8plyBecLr_YHaeGSblh5veMjVqdK4Meta || {},
    component: () => import("/codebuild/output/src387477896/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45coderP2R65q3H7xPmby7ImM3f20Qscl1g82JRXuu8ufF25YMeta || {},
    component: () => import("/codebuild/output/src387477896/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeHMKb78EPDFXWuhTeyGf4TAkUVpPqwmRqssZ8oMx0DTwMeta || {},
    component: () => import("/codebuild/output/src387477896/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerz9G7zSH_45MPFItXpF6gnlA2Pdyoka1VTEsDON1PC1xngMeta || {},
    component: () => import("/codebuild/output/src387477896/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src387477896/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmqDqfa_JsLMXUuZZldkTH3u2ZKIwbdscTJJvvlilT8cgMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeOOvr_45imNa1lWVjTVHGmIIaFhpGu2GkdYZz7PuZz7PsMMeta || {},
    component: () => import("/codebuild/output/src387477896/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexJ9FTsAUhcg_sChC6xem2p5jXdzUk_45zb3ynNkSiUuD3oMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completekGH6GPuzjGGeS9ipX4xaNKRdUc5AgXys390NAufxov0Meta || {},
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src387477896/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleaMHItxcQdmcivFOgDorjujK8jMUJGhQbNALNaRD1oFoMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailQO9abMdCqGBCcHXFM5sPNLGQdww99Ci3wdQ_45INuWsm0Meta || {},
    component: () => import("/codebuild/output/src387477896/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmaO1YnkyiqPhxfbXytpvxfC_45bHG6JP099ARaRCa_45HU20Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentmtqrHc8ZU2p7BUwPifow9bR1JT9xme81lDKqsWzfJLsMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmnOGt0wxMFiTZrATvJ7uWCt9ZdfOyoCMDEhl4kiihmHYMeta || {},
    component: () => import("/codebuild/output/src387477896/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src387477896/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completemKq55I7_454OJzxQ8vlcQQDbMblneIi18xvJ7H3tDBkT0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code1hdFF_45PlplRNeDzZdSXN_45ufSI10YIF9fmBwKAPoP3D8Meta || {},
    component: () => import("/codebuild/output/src387477896/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordCaQDRz3BLeqDdk53dJGTovAXPvGLG7G7p7bzS0rUr8sMeta || {},
    component: () => import("/codebuild/output/src387477896/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src387477896/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerlMPOjo3XKpTJj_45koLmiPlGY_Eg_45kPO2zGlzLqy3I8YQMeta || {},
    component: () => import("/codebuild/output/src387477896/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codefQO5oA0ZLp3MB01n72BaYL74HPSLMMxPveCz7QBqVTUMeta || {},
    component: () => import("/codebuild/output/src387477896/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src387477896/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src387477896/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src387477896/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src387477896/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src387477896/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src387477896/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src387477896/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src387477896/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src387477896/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]